module.exports = __webpack_public_path__ + "static/media/1005247.240ba802.png";